import { useLayoutEffect } from 'react';
import { Outlet } from '@tanstack/react-router';
import AuthProvider from '../providers/AuthProvider';
import QueryProvider from '../providers/QueryProvider';
import { LoadingContext } from '@excent-one/react/context/LoadingContext';
import { NotificationContainer } from '@excent-one/react/notification';
import DialogBoxContainer from '@excent-one/react/dialog-box';
import { PORTAL_ROOT_ID } from '@phrmpc/shared/constants';
import { appName, authEnabled } from '../config';

const RootLayout = () => {
  useLayoutEffect(() => {
    document.title = appName;
  }, []);

  return (
    <AuthProvider enabled={authEnabled} loginUrl="/auth/login" logoutUrl="/auth/login">
      <QueryProvider>
        <LoadingContext.Provider value={{}}>
          <Outlet />
          <NotificationContainer position="top-right" />
          <DialogBoxContainer rootId={PORTAL_ROOT_ID} />
        </LoadingContext.Provider>
      </QueryProvider>
    </AuthProvider>
  );
};

export default RootLayout;
